import { apiClient } from "./apiClient";

export const settlementDraftParticipantSettingsAPI = {
  getAll: (tripGuid) => apiClient.get(`/Finance/trips/${tripGuid}/settlement-draft/participant-settings`),
  set: (tripGuid, participantGuid, data) => apiClient.put(`/Finance/trips/${tripGuid}/settlement-draft/participant-settings/${participantGuid}`, data),
};
